import type React from 'react'

const FileSvg: React.FC = () => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="15" y="35.999" width="50" height="35" fill="white" />
      <path
        d="M11.5 21.499V57.999C11.5 59.6814 12.8176 60.999 14.5 60.999H65.5C67.0941 60.999 68.5 59.6915 68.5 57.999V21.499C68.5 19.8948 67.1043 18.499 65.5 18.499H14.5C12.8075 18.499 11.5 19.9049 11.5 21.499ZM29.5 57.499H15V47.999H29.5V57.499ZM29.5 44.499H15V34.999H29.5V44.499ZM47 57.499H33V47.999H47V57.499ZM47 44.499H33V34.999H47V44.499ZM65 57.499H50.5V47.999H65V57.499ZM65 44.499H50.5V34.999H65V44.499ZM65 31.499H15V21.999H65V31.499Z"
        fill="#18C4A9"
        stroke="#18C4A9"
      />
    </svg>
  )
}

export default FileSvg
